import React from 'react';
import ResponsiveCarousel from './ResonsiveCarousel';

function About() {
    return(
        <>
            <ResponsiveCarousel />
        </>
    )
}

export default About;